import { IonRow } from '@ionic/react';
import styled from 'styled-components';

export const MyIonRow = styled(IonRow)`
  justify-content: center;
`;
